import Competition from '@polleverywhere/core/lib/models/competition'
import { getSlideDataForJoinInstructions } from './sync'
import { bindings } from '../'
import { createSlideSet } from './slideset.js'
import { defaults } from 'underscore'

export async function insertSlides (models = [], options = {}) {
  options = defaults(options, {
    insertionType: 'activities'
  })

  bindings.publishEvent(bindings.operationProgressEvent, 'insertSlides', { code: 'SLIDE_SET_CREATE' })
  const slideSet = await createSlideSet([], {
    target: options.insertionType === 'images' ? 'results' : 'presentation'
  })

  models.forEach((model) => {
    slideSet.addActivity(model, {
      // Only expand slides for competitions
      expand: model instanceof Competition
    })
  })

  bindings.publishEvent(bindings.operationProgressEvent, 'insertSlides', { code: 'SLIDE_SET_GET_DATA' })
  const [activityTitles, activityUrls, placeholderUrls, screenshotUrls] = slideSet.getData({ format: 'native' })

  switch (options.insertionType) {
    case 'polls':
    case 'activities':
    case 'surveys':
      return bindings.insertActivities(activityTitles, activityUrls, placeholderUrls)
    case 'images':
      return bindings.insertImagesByUrl(activityTitles, screenshotUrls)
    default:
      throw new Error(`Insertion type of '${options.insertionType}' is not supported.`)
  }
}

export function insertFlowSlides (slidesets = []) {
  const activityTitles = []
  const activityUrls = []
  const placeholderUrls = []

  slidesets.forEach((slideset) => {
    const [setTitles, setUrls, setPlaceholderUrls] = slideset.getData({ format: 'native' })
    activityTitles.push(...setTitles)
    activityUrls.push(...setUrls)
    placeholderUrls.push(...setPlaceholderUrls)
  })

  return bindings.insertActivities(activityTitles, activityUrls, placeholderUrls)
}

export async function insertJoinInstructions () {
  const slideData = await getSlideDataForJoinInstructions()
  await bindings.insertActivities([slideData.title], [slideData.activityUrl], [slideData.placeholderUrl])
}
